export const goals2025 = {
  pushups: 10000,
  situps: 5000,
  jacks: 5000,
  stairs: 50,
  pullups: 1000,
};
